import styled from "@emotion/styled";
import { color } from "./color";

const headerHeight = "4rem";
// closedMenuWidth = -menuWidth + 35px;
const closedMenuOffset = "-199px";
// 1rem = 18px
const menuWidth = "13rem";
const paddingTop = "1.5rem";

export const SettingsHeader = styled.div`
  color: white;
  background-color: ${color.primaryBlue};
  height: ${headerHeight};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 5vw;
  img {
    width: 2.5rem;
    height: 2.5rem;
    margin-right: 0.5rem;
  }
  span.primary {
    font-size: 1rem;
    letter-spacing: 0.2rem;
    font-weight: bold;
    color: white;
  }
  .separator {
    height: 1.75rem;
    width: 1px;
    background-color: white;
    margin: 0 0.5rem;
  }
  .arrow {
    margin: 0 0.25rem;
  }
`;
export const SettingsContentContainer = styled.div`
  display: flex;
  width: 100vw;
  padding-left: ${(props: { isOpen: boolean }) =>
    props.isOpen ? menuWidth : `0`};
  transition: 0.1s padding ease-in-out;
`;
export const SettingsMenu = styled.div`
  position: absolute;
  left: ${(props: { isOpen: boolean }) =>
    props.isOpen ? "0px" : closedMenuOffset};
  width: ${menuWidth};
  height: calc(100vh - ${headerHeight});
  display: flex;
  align-items: center;
  transition: left 0.1s ease-in-out;
  color: white;
  .container {
    width: 100%;
    height: 100%;
    background-color: ${color.primaryBlue};
    overflow: hidden;
    padding-top: ${paddingTop};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .back-btn {
      margin: 0 0rem 2rem 2rem;
      span {
        user-select: none;
        cursor: pointer;
      }
    }
  }
  .tab {
    background-color: ${color.primaryBlue};
    padding: 0.5rem;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    z-index: 1000;
  }
  a {
    color: white;
  }
  .link {
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    transition: 0.1s color ease-in-out;
    .arrow {
      height: 1rem;
      width: 2rem;
      display: flex;
      justify-content: flex-end;
      padding-right: 0.5rem;
      color: white;
    }
    a {
      display: inline-block;
      height: 1rem;
      margin: 0;
    }
  }
`;
export const SettingsContainer = styled.div`
  width: 100%;
  padding: ${paddingTop} 1rem 0 1rem;
`;
export const StyledForm = styled.form`
  width: 90%;
  margin: auto;
  .table-container {
    margin-bottom: 1rem;
    overflow-x: auto;
  }
`;
export const StyledTable = styled.table`
  width: 100%;
  border-left: 1px ${color.borderGray} solid;
  border-right: 1px ${color.borderGray} solid;
  border-bottom: 1px ${color.borderGray} solid;
  th {
    background-color: ${color.primaryBlue};
    color: white;
    padding: 8px 8px 8px 0;
    border-left: 1px white solid;
    &:first-of-type {
      padding-left: 8px;
      border-top-left-radius: 5px;
      width: 50%;
      min-width: 10rem;
      text-align: left;
    }
    &:nth-child(2) {
      text-align: center;
      min-width: 4rem;
    }
    &:nth-child(3) {
      text-align: center;
      min-width: 5rem;
    }
    &:nth-child(4) {
      text-align: center;
      min-width: 10rem;
    }
    &:last-child {
      border-top-right-radius: 5px;
    }
  }
  td {
    padding: 0.5rem;
    text-align: center;
    border-left: 1px ${color.borderGray} solid;
    &:first-of-type {
      text-align: left;
      width: 50%;
    }
  }
  tr {
    width: 100%;
    border-bottom: 1px ${color.borderGray} solid;
    background-color: white;
    transition: 0.1s background-color ease-in-out;

    &:hover {
      background-color: #ccc;
    }
  }
`;
export const StyledButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  button {
    border: none;
    color: white;
    background-color: ${color.markedSecondary};
    padding: 8px;
    border-radius: 5px;
    &.secondary {
      background-color: white;
      color: ${color.markedSecondary};
      border: 1px ${color.markedSecondary} solid;
    }
  }
`;
export const StyledRadioCheckbox = styled.input`
  height: 1rem;
  width: 1rem;
`;
